import { render, staticRenderFns } from "./SideBarActivities.vue?vue&type=template&id=73c421ec&"
import script from "./SideBarActivities.vue?vue&type=script&lang=js&"
export * from "./SideBarActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports